export const mapFromDirectionName = "mapFrom";
export const mapToDirectionName = "mapTo";
